import { render } from "./PartnershipBoardWriteModal.vue?vue&type=template&id=62046b43&scoped=true&ts=true"
import script from "./PartnershipBoardWriteModal.vue?vue&type=script&lang=ts"
export * from "./PartnershipBoardWriteModal.vue?vue&type=script&lang=ts"

import "./PartnershipBoardWriteModal.vue?vue&type=style&index=0&id=62046b43&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62046b43"]])

export default __exports__